export default __webpack_public_path__ + "static/media/slider-img3.ff2d6763.png";